(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory(require('./better-commerce-core.js'));else root.BetterCheckout=factory(root.BetterCommerce);})(typeof globalThis!=='undefined'?globalThis:this,function(C){
 'use strict';
 // Platform adapter. Disabled in all delivered templates until backend readiness is verified.
 async function prepare(config,pricing,q,options={}){
  if(!config.enabled||(!config.backendVerified||pricing.volumeProposal))throw new Error('Checkout is not activated for this preview.');
  if(config.pricingMode&&!['selling-plan','native-order-discount'].includes(config.pricingMode))throw new Error('The checkout pricing mode is not supported.');
  const native=C.nativeMode(config);
  const codeOnce=!config.eligibilityEndpoint&&config.giftPolicy==='code-once';
  if(native){
   if(!config.nativeOrderDiscount?.enabled)throw new Error('Native order-discount checkout is not activated.');
   const current=C.quote(pricing,q.type,q.quantity);
   if(['baseUnit','saleActive','firstUnit','regularUnit','firstTotal','regularTotal','renewalTotal','giftQuantity'].some(key=>q[key]!==current[key]))throw new Error('Your price selection changed. Please choose your quantity again.');
  }
  if(config.currency!=='USD')throw new Error('This offer is currently available in USD only.');
  const starts=Date.parse(pricing.startsAt),ends=Date.parse(pricing.endsAt);
  if(pricing.saleActive&&(!Number.isFinite(starts)||!Number.isFinite(ends)||starts>=ends||Date.now()<starts||Date.now()>=ends))throw new Error('The sale schedule needs to be verified before checkout.');
  const fetcher=options.fetch||globalThis.fetch;
  const base=config.root||'/';
  const flow=options.flowId||getFlowId();
  const call=async(path,body)=>{
   const response=await fetcher(base+path,{method:body?'POST':'GET',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},...(body?{body:JSON.stringify(body)}:{})});
   let data;try{data=await response.json()}catch{throw new Error('The store returned an unreadable response. Please try again.');}
   if(!response.ok)throw new Error(data.description||data.message||'The store could not prepare this selection.');
   return data;
  };
  let cart=await call('cart.js');
  if(C.nativeMode(config)&&config.nativeOrderDiscount?.automatic===true&&(cart.discount_codes||[]).length){
   // No code is needed for this offer. A code left over from a link or an earlier visit would only get in the way, so it is cleared before anything is checked.
   await call('cart/update.js',{discount:''});cart=await call('cart.js');
  }
  const stale=cart.items.filter(l=>l.properties?._better_role&&l.properties?._better_flow_id!==flow);
  if(stale.length){
   // Lines this page added in an earlier tab or visit are the same offer, not someone else's items. The current selection replaces them; keeping them would double the order and trip the other-subscription check.
   await call('cart/update.js',{updates:Object.fromEntries(stale.map(l=>[l.key,0]))});cart=await call('cart.js');
  }
  if(cart.currency!=='USD')throw new Error('Your cart currency does not match this offer.');
  const unrelated=cart.items.filter(l=>l.properties?._better_flow_id!==flow);
  if(unrelated.length&&!options.confirmExisting)return{needsConfirmation:true,existingQuantity:unrelated.reduce((a,l)=>a+l.quantity,0)};
  if(native)C.nativeCartReady(cart,config,flow);
  if(q.type==='subscription'){
   const standardRequested=options.standardSelection;
   const standardQuote=C.quote({...pricing,saleActive:false},'subscription',q.quantity);
   const standardId=String(config.standardPlanIds?.[q.quantity-1]||'');
   const standardAllocation=config.allocations?.find(a=>String(a.id)===standardId);
   const standardReady=standardId&&standardAllocation?.initialPrice===standardQuote.firstUnit&&standardAllocation?.renewalPrice===standardQuote.regularUnit&&Array.isArray(standardAllocation.adjustmentPrices)&&standardAllocation.adjustmentPrices.length>0&&standardAllocation.adjustmentPrices.every(price=>price===standardQuote.regularUnit);
   if(standardRequested){
    if(!standardReady)throw new Error('A verified standard subscription is not available for this quantity yet.');
    if(standardRequested.quantity!==q.quantity||String(standardRequested.planId)!==standardId||standardRequested.firstTotal!==standardQuote.firstTotal||standardRequested.renewalTotal!==standardQuote.renewalTotal)throw new Error('Your standard subscription option changed. Please choose your quantity again to review the updated price.');
    q=standardQuote;
    config={...config,planIds:config.standardPlanIds};
   }
   const planId=String(config.planIds?.[q.quantity-1]||'');
   const allocation=config.allocations?.find(a=>String(a.id)===planId);
   if(native){
    // Introductory savings live in an order discount; this allocation must remain
    // at the regular monthly unit price throughout, including its initial charge.
    if(!allocation||allocation.initialPrice!==q.regularUnit||allocation.renewalPrice!==q.regularUnit||!Array.isArray(allocation.adjustmentPrices)||!allocation.adjustmentPrices.length||allocation.adjustmentPrices.some(price=>price!==q.regularUnit))throw new Error('The regular monthly price is not connected to a constant subscription plan.');
   }else if(!allocation||allocation.initialPrice!==q.firstUnit||allocation.renewalPrice!==q.regularUnit||(q.firstUnit!==q.regularUnit&&allocation.firstOrderCount!==1))throw new Error('The first-month and renewal prices are not connected to a verified subscription plan.');
   if(!codeOnce&&(!config.eligibilityEndpoint||!config.eligibilityEndpoint.startsWith('/apps/')))throw new Error('First-time subscriber eligibility must be connected before checkout.');
   // App-proxy backend must authenticate Shopify proxy signature/customer and enforce the
   // same rules in checkout validation/discounts; this client response alone is not security.
   let eligibility;
   if(codeOnce){
    // Shopify enforces one use of this offer per customer; this is not historical subscription eligibility. If refused in this cart, remove the gift before redirecting.
    eligibility={firstTimeSubscriber:true,welcomeMugEligible:true,introductoryPriceEligible:true};
   }else{
    const eligibilityResponse=await fetcher(config.eligibilityEndpoint,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({quantity:q.quantity,variantId:config.variantId,planId,cartToken:cart.token})});
    if(!eligibilityResponse.ok)throw new Error('We could not verify welcome-offer eligibility. Please sign in and try again.');
    eligibility=await eligibilityResponse.json();
   }
   if(typeof eligibility.welcomeMugEligible!=='boolean'||typeof eligibility.firstTimeSubscriber!=='boolean')throw new Error('Welcome-gift eligibility could not be verified.');
   if(q.firstUnit<q.regularUnit&&typeof eligibility.introductoryPriceEligible!=='boolean')throw new Error('Introductory-price eligibility could not be verified.');
   if(eligibility.welcomeMugEligible&&!eligibility.firstTimeSubscriber)throw new Error('Welcome-gift eligibility is inconsistent.');
   if(!standardRequested&&q.firstUnit<q.regularUnit&&eligibility.introductoryPriceEligible===false){
    if(!standardReady)throw new Error('This introductory price is unavailable for your account. A verified standard subscription is not available for this quantity yet.');
    return{needsStandardChoice:true,offer:{...standardQuote,giftQuantity:eligibility.welcomeMugEligible?1:0,planId:standardId}};
   }
   if(standardRequested&&standardRequested.giftQuantity!==(eligibility.welcomeMugEligible?1:0))throw new Error('Your welcome-gift eligibility changed. Please choose your quantity again to review your order.');
   // Buying a subscription and receiving a welcome gift are separate decisions.
   q={...q,giftQuantity:eligibility.welcomeMugEligible?1:0};
  }
  const desired=C.desiredItems(config,q,flow);
  if(native){
   const discounts=C.nativeDiscounts(config,q);
   const baseline=C.unrelatedSnapshot(cart,flow);
   const matches=candidate=>{
    const lines=C.owned(candidate,flow);
    return lines.every(l=>desired.some(item=>item.properties._better_role===l.properties?._better_role))&&desired.every(item=>{
     const matching=lines.filter(l=>l.properties?._better_role===item.properties._better_role);
     const splitAllowed=item.properties._better_role==='booster'&&item.selling_plan;
     return matching.length>0&&(splitAllowed||matching.length===1)&&matching.every(l=>Number(l.variant_id)===item.id&&Number.isSafeInteger(l.quantity)&&l.quantity>0&&String(l.selling_plan_allocation?.selling_plan?.id||'')===String(item.selling_plan||''))&&matching.reduce((sum,l)=>sum+l.quantity,0)===item.quantity;
    });
   };
   if(!matches(cart)){
    let current=cart;
    // Discount application changes line keys: re-read after every removal.
    while(C.owned(current,flow).length){
     const count=C.owned(current,flow).length;
     await call('cart/change.js',{id:C.owned(current,flow)[0].key,quantity:0});
     current=await call('cart.js');
     if(C.owned(current,flow).length>=count)throw new Error('The previous cart selection could not be replaced.');
    }
    try{await call('cart/add.js',{items:desired});}
    catch(error){if(!matches(await call('cart.js')))throw error;}
   }
   const beforeDiscount=await call('cart.js');
   C.nativeCartReady(beforeDiscount,config,flow);
   if(C.unrelatedSnapshot(beforeDiscount,flow)!==baseline)throw new Error('Other items in your cart changed. Please review your cart before checkout.');
   // Official Ajax Cart API supports comma-separated codes on update.js. An OK
   // response (or discount query parameter) does not establish actual savings.
   await call('cart/update.js',{discount:discounts.codes.join(',')});
   let verified=await call('cart.js');
   if(C.unrelatedSnapshot(verified,flow)!==baseline)throw new Error('Other items in your cart changed. Please review your cart before checkout.');
   try{C.validateCart(verified,q,config,flow);}
   catch(error){
    // A refused gift must not be carried into checkout as a paid line. Revalidate the remaining order after removal.
    const giftLines=C.owned(verified,flow).filter(l=>l.properties?._better_role==='welcome-mug');
    if(!(codeOnce&&q.giftQuantity&&giftLines.length))throw error;
    for(const line of giftLines)await call('cart/change.js',{id:line.key,quantity:0});
    q={...q,giftQuantity:0};
    const retry=C.nativeDiscounts(config,q);
    await call('cart/update.js',{discount:retry.codes.join(',')||''});
    verified=await call('cart.js');
    if(C.unrelatedSnapshot(verified,flow)!==baseline)throw new Error('Other items in your cart changed. Please review your cart before checkout.');
    C.validateCart(verified,q,config,flow);
   }
   return{checkoutUrl:base+'checkout',verification:{scope:'cart',offerFirstTotal:q.firstTotal,recurringSubtotal:q.renewalTotal}};
  }
  const existing=C.owned(cart,flow);
  if(existing.length){
   try{C.validateCart(cart,q,config,flow);return{checkoutUrl:base+'checkout'};}catch{}
   // Replace only lines previously created by this exact configurator session.
   for(const line of existing)await call('cart/change.js',{id:line.key,quantity:0});
  }
  let added;
  try{added=await call('cart/add.js',{items:desired});}
  catch(error){
   // An interrupted response may still have added the items. Reconcile before a retry.
   const after=await call('cart.js');
   try{C.validateCart(after,q,config,flow);return{checkoutUrl:base+'checkout'};}catch{throw error;}
  }
  const finalCart=await call('cart.js');
  C.validateCart(finalCart,q,config,flow);
  // A free mug must be a zero-price NON-subscription line; failed checks never redirect.
  // Existing unrelated cart lines are neither cleared nor rewritten.
  return{checkoutUrl:base+'checkout'};
 }
 function getFlowId(){
  const key='better-checkout-flow';let value=sessionStorage.getItem(key);
  if(!value){value=crypto.randomUUID();sessionStorage.setItem(key,value)}return value;
 }
 return{prepare};
});
